import FlyerAdultBirthdayTile from './Assets/flyerTiles/tile_adultbirthday.jpg';
import FlyerBabyShowerTile from './Assets/flyerTiles/tile_babyshower.jpg';
import FlyerBrunchTile from './Assets/flyerTiles/tile_brunch.jpg';
import FlyerCocktailPartyTile from './Assets/flyerTiles/tile_cocktailparty.jpg';
import FlyerDinnerPartyTile from './Assets/flyerTiles/tile_dinnerparty.jpg';
import FlyerEngagementPartyTile from './Assets/flyerTiles/tile_engagementparty.jpg';
import FlyerGetTogethersTile from './Assets/flyerTiles/tile_gettogethers.jpg';
import FlyerHappyHourTile from './Assets/flyerTiles/tile_happyhour.jpg';
import FlyerHousewarmingTile from './Assets/flyerTiles/tile_housewarming.jpg';
import FlyerKidsBirthdayTile from './Assets/flyerTiles/tile_kidsbirthday.jpg';
import FlyerProfessionalTile from './Assets/flyerTiles/tile_professional.jpg';
import FlyerWeddingShowerTile from './Assets/flyerTiles/tile_weddingshower.jpg';
import FlyerHolidayTile from './Assets/flyerTiles/tile_holiday.jpg';
import FlyerWinterPartiesTile from './Assets/flyerTiles/tile_winterparties.jpg';
import FlyerNewYearTile from './Assets/flyerTiles/tile_newyear.jpg';
import FlyerBacheloretteTile from './Assets/flyerTiles/tile_bachelorette.jpg';
import FlyerGameNightTile from './Assets/flyerTiles/tile_gamenight.jpg';
import FlyerGalentinesTile from './Assets/flyerTiles/tile_galentines.jpg';
import FlyerSaveTheDateTile from './Assets/flyerTiles/tile_savethedate.jpg';
import FlyerSpringPartiesTile from './Assets/flyerTiles/tile_springparties.jpg';
import FlyerSportsTile from './Assets/flyerTiles/tile_sports.jpg';
import FlyerStPatricksDayTile from './Assets/flyerTiles/tile_stpatricksday.jpg';

import DesktopHeroVideo from './Assets/DesktopHero.mp4';
import DesktopHeroPoster from './Assets/DesktopHeroPoster.jpg';

import Block1Image from './Assets/Block1.png';
import Block1ImageMobile from './Assets/Block1_Mobile.png';
import Block2Image from './Assets/Block2.png';
import Block2ImageMobile from './Assets/Block2_Mobile.png';
import Block3Image from './Assets/Block3.png';
import Block3ImageMobile from './Assets/Block3_Mobile.png';
import Block4Image from './Assets/Block4.png';
import Block4ImageMobile from './Assets/Block4_Mobile.png';

import MobileHeroSlat2Image from './Assets/MobileHeroSlat2.jpg';
import MobileHeroSlat3Image from './Assets/MobileHeroSlat3.jpg';

import Seasonal from './Assets/Seasonal.png';
import SeasonalMobile from './Assets/SeasonalMobile.png';

import Upload from './Assets/UploadYourOwn.png';
import UploadMobile from './Assets/UploadYourOwn_Mobile.png';

import PaperSourceImage from '../Shared/PaperSource/PaperSourceWeddingBanner.png';

import MobileHeroPoster from './Assets/MobileHeroPoster.png';
import MobileHeroVideo from './Assets/MobileHeroVideo.mp4';

import CardsPoster from './Assets/CardsPoster.jpg';
import CardsVideo from './Assets/CardsVideo.mp4';
import FlyerPoster from './Assets/FlyerPoster.jpg';
import FlyerVideo from './Assets/FlyerVideo.mp4';

import colors from '../../../styling/colors';

export default {
  seo: {
    description:
      'Customize online cards, invitations, and flyers that reflect your personal style -- for weddings, holidays, birthdays, and other meaningful events.',
    title: 'Online invitations, cards and flyers - Paperless Post',
  },
  hero: {
    tracking: {
      block_name: 'hero',
      block_row: 1,
    },
  },
  desktopHero: {
    tracking: {
      block_name: 'hero',
      block_row: 1,
    },
    title: 'Online invitations that make gathering easier',
    button1: {
      children: "Kids' birthday",
      backgroundColor: 'lapel',
      borderRadius: '17.5px',
      href: '/cards/category/kids-birthday-invitations',
      type: 'TrackedLink',
    },
    button2: {
      children: 'Wedding',
      backgroundColor: 'lapel',
      borderRadius: '17.5px',
      href: '/cards/group/wedding-invitations',
      type: 'TrackedLink',
    },
    button3: {
      children: 'Get-togethers',
      backgroundColor: 'lapel',
      borderRadius: '17.5px',
      href: '/cards/group/get_togethers',
      type: 'TrackedLink',
    },
    button4: {
      children: "St. Patrick's Day",
      backgroundColor: 'lapel',
      borderRadius: '17.5px',
      href: '/cards/category/st-patricks-day-invitations?tab=flyers',
      type: 'TrackedLink',
    },
    button5: {
      children: 'Browse all',
      backgroundColor: 'lapel',
      borderRadius: '17.5px',
      href: '/cards/section/invitations',
      type: 'TrackedLink',
    },
    media: {
      type: 'video',
      layout: 'center',
      video: DesktopHeroVideo,
      image: DesktopHeroPoster,
    },
  },
  desktopHeroSecondary: {
    tracking: {
      block_name: 'product_comparison',
      block_row: 2,
    },
    withBorderOnHover: true,
    title: 'An invitation for every occasion.',
    cards: {
      media: {
        type: 'video',
        video: CardsVideo,
        mobileVideo: CardsVideo,
        poster: CardsPoster,
        imageSize: 'contain',
      },
      title: 'Cards',
      description: 'Classic stationery-inspired\u00A0designs',
      checkList: {
        list: [
          {
            checkItem: 'Exclusive partner\u00A0collections',
          },
          { checkItem: 'Upload CSV contacts and export guest\u00A0list' },
          {
            checkItem: 'Collect RSVPs, and track email opens and\u00A0bounces',
          },
        ],
      },
      button: {
        borderRadius: '0',
        color: 'lapel',
        children: 'Browse Cards',
        href: '/online-invitations',
        type: 'DefaultButton',
      },
      mobileButton: {
        children: 'Browse Cards',
        href: '/online-invitations',
        color: colors('apache'),
        type: 'TrackedLink',
        hideUnderline: true,
      },
    },
    flyer: {
      media: {
        type: 'video',
        video: FlyerVideo,
        mobileVideo: FlyerVideo,
        poster: FlyerPoster,
        imageSize: 'contain',
      },
      title: 'Flyers',
      description: 'Easy templates you can\u00A0customize',
      checkList: {
        list: [
          {
            checkItem:
              'Add stickers, GIFs, text effects, or your own\u00A0photo',
          },
          { checkItem: 'Send a free link via text or social\u00A0media' },
          { checkItem: 'Follow up with guests once they\u00A0RSVP' },
        ],
      },
      button: {
        borderRadius: '0',
        color: 'lapel',
        children: 'Browse Flyers',
        href: '/flyer',
        type: 'DefaultButton',
      },
      mobileButton: {
        children: 'Browse Flyers',
        href: '/flyer',
        color: colors('apache'),
        type: 'TrackedLink',
        hideUnderline: true,
      },
    },
  },
  mobileHeroSlat1: {
    slatProps: {
      backgroundColor: 'transparent',
      mobileBackgroundColor: '#a17e48',
      color: 'white',
      height: 'auto',
      mobileHeight: '120vw',
      layout: 'center',
      contentColumnSizing: { xs: 6 },
      mediaColumnSizing: { xs: 6 },
    },
    backgroundVideo: {
      type: 'video',
      mobileVideo: MobileHeroVideo,
      poster: MobileHeroPoster,
    },
    heading: 'Online invitations that make gathering easier.',
    button: {
      href: '/flyer',
      children: 'Get started',
      type: 'TrackedLink',
      color: 'white',
    },
  },
  flyerCategories: {
    tiles: [
      {
        name: "Kids' birthday",
        href: '/cards/category/kids-birthday-invitations?tab=flyers&page=1',
        image: FlyerKidsBirthdayTile,
      },
      {
        name: 'Adult birthday',
        href:
          '/cards/category/birthday_invitations_for_adults?tab=flyers&page=1',
        image: FlyerAdultBirthdayTile,
      },
      {
        name: 'Baby shower',
        href: '/cards/category/baby-shower-invitations?tab=flyers&page=1',
        image: FlyerBabyShowerTile,
      },
      {
        name: "St. Patrick's Day",
        href: '/cards/category/st-patricks-day-invitations?tab=flyers',
        image: FlyerStPatricksDayTile,
      },
      {
        name: 'Get-togethers',
        href: '/cards/group/get_togethers?tab=flyers&page=1',
        image: FlyerGetTogethersTile,
      },
      {
        name: 'Wedding Shower',
        href: '/cards/category/bridal-shower-invitations?tab=flyers',
        image: FlyerWeddingShowerTile,
      },
      {
        name: 'Professional',
        href: '/cards/group/business-event-invitations?tab=flyers&page=1',
        image: FlyerProfessionalTile,
      },
      {
        name: 'Happy hour',
        href: '/cards/category/happy-hour-invitations?tab=flyers',
        image: FlyerHappyHourTile,
      },
      {
        name: 'Bachelorette',
        href: '/cards/category/bachelorette-party-invitations?tab=flyers',
        image: FlyerBacheloretteTile,
      },
      {
        name: 'Spring parties',
        href: '/cards/category/spring-entertaining-invitations?tab=flyers',
        image: FlyerSpringPartiesTile,
      },
      {
        name: 'Save the dates',
        href: '/cards/group/save-the-dates?tab=flyers&page=1',
        image: FlyerSaveTheDateTile,
      },
      {
        name: 'Sports',
        href: '/cards/category/sporting-event-invitations?tab=flyers',
        image: FlyerSportsTile,
      },
      {
        name: 'Engagement party',
        href: '/cards/category/engagement-party-invitations?tab=flyers&page=1',
        image: FlyerEngagementPartyTile,
      },
      {
        name: 'Dinner party',
        href: '/cards/category/dinner-party-invitations?tab=flyers',
        image: FlyerDinnerPartyTile,
      },
      {
        name: 'Housewarming',
        href: '/cards/category/housewarming-party-invitations?tab=flyers',
        image: FlyerHousewarmingTile,
      },
      {
        name: 'Cocktail party',
        href: '/cards/category/cocktail-party-invitations?tab=flyers&page=1',
        image: FlyerCocktailPartyTile,
      },
    ],
  },
  mobileHeroSlat2: {
    slatProps: {
      backgroundColor: '#fff',
      color: 'lapel',
      height: '560px',
      layout: 'center',
    },
    media: {
      type: 'image',
      image: MobileHeroSlat2Image,
      mobileImage: MobileHeroSlat2Image,
    },
    heading: 'Online greeting cards',
    dek: 'Spread joy instantly with a greeting card.',
    button: {
      children: 'Send a card',
      href: '/cards/section/online-cards',
      identifier: 'hero_cards_send_a_card',
      color: 'lapel',
    },
  },
  mobileHeroSlat3: {
    slatProps: {
      backgroundColor: '#FFFBF5',
      color: 'lapel',
      layout: 'center',
    },
    media: {
      type: 'image',
      image: MobileHeroSlat3Image,
      mobileImage: MobileHeroSlat3Image,
    },
    heading: 'Classic online invitations',
    dek: 'Elegant stationery designs with sophisticated RSVP tracking.',
    button: {
      children: 'Get started',
      href: '/online-invitations',
      identifier: 'hero_cards_learn_more_about_online',
      color: 'lapel',
    },
  },

  offsetMosaic: {
    tracking: {
      block_name: 'offsetMosaic',
      block_row: 3,
    },
    categories: [
      {
        backgroundColor: 'A2D2CB',
        title: "Kids' birthday invitations",
        cta: 'Browse',
        href: '/cards/category/kids-birthday-invitations',
        image: Block1Image,
        mobileImage: Block1ImageMobile,
      },
      {
        backgroundColor: 'E5D8BE',
        title: 'Save the dates',
        cta: 'Browse',
        href: '/cards/group/save-the-dates',
        image: Block2Image,
        mobileImage: Block2ImageMobile,
      },
      {
        backgroundColor: 'FAECB6',
        title: 'General entertaining',
        cta: 'Browse',
        href: '/cards/category/spring-entertaining-invitations',
        image: Block3Image,
        mobileImage: Block3ImageMobile,
      },
      {
        backgroundColor: 'DDE4C4',
        title: 'Baby shower invitations',
        cta: 'Browse',
        href: '/cards/category/baby-shower-invitations',
        image: Block4Image,
        mobileImage: Block4ImageMobile,
      },
    ],
  },
  seasonal: {
    tracking: {
      block_name: 'seasonal',
      block_row: 4,
    },
    slatProps: {
      backgroundColor: '#E5BBBB',
      color: 'lapel',
      height: '400px',
      imageSize: 'cover',
      layout: 'right',
      contentColumnSizing: { xs: 12, sm: 5, md: 4 },
      mediaColumnSizing: { xs: 12, sm: 7, md: 8 },
    },
    media: {
      type: 'image',
      image: Seasonal,
      mobileImage: SeasonalMobile,
    },
    h3: {
      color: 'lapel',
      children: 'Adult birthday invitations',
    },
    button: {
      children: 'Browse',
      color: 'lapel',
      href: '/cards/category/birthday_invitations_for_adults',
      type: 'TrackedLink',
    },
  },
  uploadYourOwn: {
    tracking: {
      block_name: 'uploadBanner',
      block_row: 5,
    },
    slatProps: {
      backgroundColor: '#F9F2E8',
      layout: 'left',
      height: '480px',
    },
    media: {
      type: 'image',
      image: Upload,
      mobileImage: UploadMobile,
    },
    h2: 'Your design, our tools.',
    dek:
      'Have a finished design? You can upload, customize and send it using our platform.',
    button: {
      children: 'Get started',
      color: 'lapel',
      href: '/upload-your-own',
      type: 'TrackedLink',
    },
  },
  designCollectionHeading: 'Designer collections',
  designerCollections: {
    tracking: {
      block_name: 'designerCollections',
      block_row: 6,
    },
    button: {
      children: 'Browse all designers',
      color: 'lapel',
      href: '/partners',
    },
    categories: [
      {
        name: 'Kelly Wearstler',
        url: '/cards/group/kelly_wearstler',
        cards: [
          {
            title: 'Hearth',
            partner: 'Kelly Wearstler',
            image:
              'https://pi.ppassets.com/images/ppa/cards/images/549639614/original/f54bd23ba69809f2ecb421d34848941c-20-121108049?version_id=23',
            shape: 'tall',
            size: 'small',
            href: '/cards/card/36936',
          },
        ],
        color: '#242424',
      },
      {
        name: 'Sugar Paper',
        url: '/cards/group/sugar-paper',
        cards: [
          {
            title: 'Watercolor Confetti',
            partner: 'Sugar Paper',
            image:
              'https://pi.ppassets.com/images/ppa/cards/images/567334178/original/76fe054f29913f8009430b3e0498edcc-20-143532429?version_id=23',
            shape: 'square',
            size: 'small',
            href: '/cards/card/39133',
          },
        ],
        color: '#B8D5C3',
      },
      {
        name: 'Rifle Paper Co.',
        url: '/cards/group/rifle-paper-co',
        cards: [
          {
            title: 'Birthday Giraffe',
            partner: 'Rifle Paper Co.',
            image:
              'https://pi.ppassets.com/images/ppa/cards/images/565807177/original/957e70264fac5d43c66b27427b06f27f-20-141478767?version_id=23',
            shape: 'tall',
            size: 'small',
            href: '/cards/card/38910',
          },
        ],
        color: '#EE9984',
      },
      {
        name: 'Oscar de la Renta',
        url: '/cards/group/oscar-de-la-renta',
        cards: [
          {
            title: 'Stamped Greenery',
            partner: 'Oscar de la Renta',
            image:
              'https://pi.ppassets.com/images/ppa/cards/images/562623762/original/47eafa7f4fa713ce41f4e592c8b8e541-20-137395793?version_id=23',
            shape: 'square',
            size: 'small',
            href: '/cards/card/38268',
          },
        ],
        color: '#E1CB93',
      },
    ],
  },
  paperSource: {
    tracking: {
      block_name: 'paperSource',
      block_row: 7,
    },
    slatProps: {
      backgroundColor: '#f9ede7',
      layout: 'left',
      alignment: 'center',
    },
    media: {
      type: 'image',
      image: PaperSourceImage,
      mobileImage: PaperSourceImage,
    },
    h2: 'Printed wedding invitations',
    dek:
      "We've partnered with Paper Source to provide paper versions of our digital designs.",
    button: {
      href: 'http://www.kqzyfj.com/click-7152784-13097460',
      children: 'Shop at Paper Source',
      color: 'lapel',
    },
  },
  blog: {
    tags: '592',
    tracking: {
      block_name: 'blogPosts',
      block_row: 8,
    },
  },
};
